/**
 * Set body classes to control accessibility focus rings visibility for keyboard
 * users only. These classes should only be used to target specific problematic
 * elements.
 *
 * WARNING: Should be used with caution and restraint.
 *
 * Learn more: https://hackernoon.com/removing-that-ugly-focus-ring-and-keeping-it-too-6c8727fefcd2
 */

// Add class when it looks like user is tabbing
function handleFirstTab( e ) {
	if ( e.keyCode === 9 ) {
		document.body.classList.add( 'user-is-tabbing' );

		window.removeEventListener( 'keydown', handleFirstTab );
		window.addEventListener( 'mousedown', handleMouseDownOnce );
	}
}

// Edge case: User starts tabbing, but then begins using the mouse.
function handleMouseDownOnce() {
	document.body.classList.remove( 'user-is-tabbing' );

	window.removeEventListener( 'mousedown', handleMouseDownOnce );
	window.addEventListener( 'keydown', handleFirstTab );
}

window.addEventListener( 'keydown', handleFirstTab );
